<template>
  <div>
    <div
      class="page-content"
      :style="{height:contentheight+'px'}"
    >
      <div class="coupons-section">
        <div
          class="coupons-content"
        >
          <Form
            ref="formInline"
            :model="coupons.params"
            :rules="coupons.couponsRules"
          >
            <FormItem prop="activationCode">
              <div class="coupons-box">
                <Input
                  v-model="coupons.params.activationCode"
                  class="input-coupons"
                  placeholder="请输入激活码"
                  clearable
                ></Input>
                <span
                  class="coupons-query"
                  type="text"
                  @click="coupons.on.couponsQuery"
                >
                  立即激活
                </span>
                <div
                  v-if="coupons.noCouponsPrice"
                  class="error-coupons"
                >
                  无效优惠码
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
      <div
        v-if="table.data.length"
        class="table-section"
      >
        <div class="section-header">
          <span class="section-name">兑换服务：</span>
        </div>

        <Table
          :columns="table.columns"
          :data="table.data"
        >
        </Table>
        <div class="section-tip">
          <span class="common-label">订购主体：</span>{{ $store.state.user.userInfo.corpName }}
        </div>
        <!-- 应用订购需要选择系统账号 -->
        <Form
          ref="formInline1"
          inline
          :model="coupons.params"
          :rules="coupons.couponsRules"
        >
          <template v-if="$route.query.from==='appDetail'&productType!==3">
            <FormItem
              prop="accountNo"
            >
              <div class="coupons-box">
                <span class="common-label">系统账号：</span>
                <Tooltip
                  content="应用服务需在产品中使用，需要选择一个软件系统"
                  placement="top"
                  max-width="400"
                  theme="light"
                >
                  <Icon
                    type="ios-help-circle-outline"
                    size="20"
                    color="#4f78fc"
                  />
                </Tooltip>
                <Select
                  v-model="coupons.params.accountNo"
                  style="display: inline-block; width: 200px;"
                  placeholder="请选择系统账号"
                  transfer
                  clearable
                >
                  <Option
                    v-for="(item,index) in accountNoList"
                    :key="index"
                    :value="item.accountNo"
                  >
                    {{ item.accountName }}
                  </Option>
                </Select>
              </div>
            </FormItem>
            <FormItem
              v-if="appProductList.length>1"
              prop="appProductId"
              :rules="[{ required: true,type:'number', message: '请选择产品', trigger: 'blur' },]"
            >
              <Select
                v-model="coupons.params.appProductId"
                style="display: inline-block; width: 200px;"
                transfer
                placeholder="请选择产品"
              >
                <Option
                  v-for="(item,index) in appProductList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.productName }}
                </Option>
              </Select>
            </FormItem>
          </template>
        </Form>
        <div class="footer-box">
          <Button
            type="primary"
            class="sub-button"
            @click="activate"
          >
            确定使用
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data(){
    return {
      contentheight: '',
      // 优惠码
      coupons: {
        params: {
          activationCode: '',
          accountNo: '',
        },
        couponsRules: {
          activationCode: [
            { required: true, message: '请输入激活码', trigger: 'blur' },
          ],
          accountNo: [
            { required: true, message: '请选择系统账号', trigger: 'change' },
          ],
        },
        collapse: '',

        noCouponsPrice: false,
        on: {
          couponsQuery: ()=>{
            this.$refs.formInline.validate((valid)=>{
              if (valid){
                const {activationCode} = this.coupons.params;
                if (!activationCode){
                  this.$Message.warning('请先输入激活码');
                  return;
                }
                this.table.data = [];
                const {productCode} = this.$route.query;
                const {corpCode,corpName} = this.$store.state.user.userInfo;
                // const url = '/paycenter-charge/api/facade/order/calculate';
                const url = '/paycenter-charge/api/worktable/order/calculate';
                const params = {
                  productCode,
                  activationCode,
                  exchange: true,
                  corpCode,
                  corpName,
                  // accountNo,
                };
                this.$http.post(url,params).then(res => {
                  if (res.success) {
                    this.table.data = res.data.detailList;
                  } else {
                    this.$Message.warning(res.message || '无效的激活码');
                  }
                });
              }
            });


          },
        },
      },
      table: {
        visiable: false,
        columns: [
          {
            title: '兑换服务',
            key: 'saleName',
            align: 'center',
          },
          {
            title: '软件版本',
            key: 'versionName',
            align: 'center',
          },
          {
            title: '服务周期',
            key: 'servicePeriod',
            align: 'center',
          },
          {
            title: '价格',
            key: 'fee',
            align: 'center',
            render: (h,params)=>{
              const {fee} = params.row;
              const html = [];
              const span = h('span',`￥${this.$options.filters.moneyFix(fee)}`);
              html.push(span);
              return html;
            },
          },
          // {
          //   title: '系统账号',
          //   key: 'accountNo',
          //   align: 'center',
          //   asyncRender: async(item)=>{
          //     item.render;
          //   },
          //   render: ()=>{

          //   },
          // },
        ],
        data: [
        ],
      },
      accountNoList: [],
      accountNo: '',
    };
  },
  computed: {
    productType(){
      const {productType} = this.$route.query;
      return Number(productType);
    },
    appProductList(){
      const {accountNoList} = this;
      const {accountNo} = this.coupons.params;
      if (!accountNo){
        return [];
      }
      return accountNoList.find(ele=>ele.accountNo===accountNo).productList;
    },

  },
  mounted() {
    this.contentheight = window.innerHeight - 110;
  },
  created(){
    // 获取系统账号列表
    this.getAccountNo();
  },
  mounted(){
    // 头部主体变化事件绑定
    // 防止多次监听
    // this.$root.$off('on-corp-change');
    this.$root.$on('on-corp-change', () => {
      // 重新获取已订购的产品
      this.coupons.params.accountNo = '';
      this.getAccountNo();
    });
  },
  beforeDestroy(){
    this.$root.$off('on-corp-change');
  },
  methods: {
    // 获取系统账号列表
    getAccountNo() {
      const {corpCode,token} = this.$store.state.user.userInfo;
      if (token){
        const url = '/paycenter-charge/api/worktable/list/accountNo';
        const params = {
          productCode: this.$route.query.productCode,
          corpCode,
        };

        this.$http.get(url,params).then(res => {
          if (res.success) {
            this.accountNoList = res.data;
          } else {
            this.$Message.warning(res.message || '获取详情失败');
          }
        });
      }

    },
    // 去兑换
    activate(){
      this.$refs.formInline1.validate((valid)=>{
        if (valid){
          this.$Modal.confirm({
            title: '激活',
            content: ' 确认激活？',
            onOk: () => {
              const {
                productCode,
                unifiedEntityId,
                pid,
              } = this.$route.query;
              // productType是3 接口应用 才有 unifiedEntityId, pid,
              const {activationCode,accountNo,appProductId} = this.coupons.params;
              const {corpCode,corpName} = this.$store.state.user.userInfo;
              // const url = '/paycenter-charge/api/facade/order/exchange';
              const url = '/paycenter-charge/api/worktable/order/exchange';
              const params = {
                productCode,
                activationCode,
                exchange: true,
                corpCode,
                corpName,
                accountNo,
                unifiedEntityId,
                pid,
                appProductId,
              };
              this.$http.post(url,params).then(res => {
                if (res.success) {
                  this.$Message.success('激活成功');
                  this.$router.push({
                    path: '/standardProduct/exchange/activateResult',
                    query: {
                      orderNo: res.data.orderNo,
                    },
                  });
                } else {
                  this.$Message.warning(res.message || '商品规格价格计算失败');
                }
              });


            },
          });

        }
      });
    },

  },
};
</script>
<style lang="less" scoped>
.common-label {
  font-size: 14px;
  color: #333;
}
.page-content {
  background-color: #fff;
}
.coupons-section {
  width: 740px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 100px 0;
  .ivu-collapse-simple {
    border: 0;
  }
  .input-coupons {
    box-sizing: border-box;
    outline: 0;
    border: 1px solid #c4c6cf;
    border-radius: 2px;
    margin-right: 10px;
    padding-left: 18px;
    /deep/ .ivu-input {
      border: 0;
      outline: 0;
      color: #999;
      height: 52px;
      line-height: 52px;
      font-size: 14px;
      &:focus {
        box-shadow: 0 0;
      }
      &::placeholder {
        color: #999;
      }
    }
    /deep/ .ivu-input-icon {
      line-height: 52px;
      height: 52px;
    }
  }
  .input-select {
    // width: 80%;
    box-sizing: border-box;
    outline: 0;
    border: 1px solid #999;
    border-radius: 2px;
    padding: 5px 15px;
    margin-right: 10px;
    display: inline-block;
    /deep/ .ivu-select-selection {
      border: 0;
      outline: 0;
      color: #999;
      &:focus {
        box-shadow: 0 0;
      }
      .ivu-select-placeholder {
        color: #999;
      }
    }
  }

  .coupons-query {
    width: 136px;
    height: 54px;
    background-color: #4772fc;
    color: #fff;
    text-align: center;
    padding: 12px 20px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 400;
    border-radius: 2px;
  }
  .error-coupons {
    color: #ed4014;
    font-size: 12px;
    padding-top: 5px;
  }
}
.table-section {
  width: 730px;
  box-sizing: border-box;
  margin: 0 auto;
  .section-header {
    margin-bottom: 20px;
  }
  .section-name {
    .common-label;
  }
  .section-tip {
    margin: 24px 0 24px 0;
  }
}
  .coupons-box {
    display: flex;
    align-items: center;
    /deep/.ivu-tooltip-rel{
      display: flex;
      align-items: center;
      margin-left: 10px;
    }
  }
.footer-box {
  text-align: center;
  padding: 100px 0;
  .sub-button {
    width: 94px;
    height: 38px;
    border-radius: 2px;
    font-size: 16px;
    background-color: #4772fc;
  }
}

</style>
